import React from 'react';
import PropTypes from 'prop-types';
import { SORT_OPTIONS, COMPLETION_OPTIONS, ORIGIN_OPTIONS } from '../constants/filterOptions';

const FilterIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <line x1="1" y1="14" x2="7" y2="14" />
    <line x1="9" y1="8" x2="15" y2="8" />
    <line x1="17" y1="16" x2="23" y2="16" />
  </svg>
);

const BrowseToolbar = ({
  filters,
  onQuickFilterChange,
  onOpenFilterPanel,
  onClearFilters,
  activeFilterCount,
  hasActiveFilters,
  loading,
}) => {
  return (
    <div className="library-page__toolbar filter-toolbar" role="toolbar" aria-label="Filter toolbar">
      <div className="filter-group filter-group--primary">
        {/* Sort Dropdown */}
        <div className="select-shell">
          <select
            value={filters.sort || 'lastContentUpdatedAt,DESC'}
            onChange={(e) => onQuickFilterChange('sort', e.target.value)}
            aria-label="Sort novels"
          >
            {SORT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Status Dropdown */}
        <div className="select-shell">
          <select
            value={filters.isCompleted || 'any'}
            onChange={(e) => onQuickFilterChange('isCompleted', e.target.value)}
            aria-label="Filter by status"
          >
            {COMPLETION_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Origin Dropdown */}
        <div className="select-shell">
          <select
            value={filters.originCountry || ''}
            onChange={(e) => onQuickFilterChange('originCountry', e.target.value)}
            aria-label="Filter by origin"
          >
            {ORIGIN_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="filter-group filter-group--actions">
        <button
          type="button"
          className={`toolbar-filter-btn${hasActiveFilters ? ' toolbar-filter-btn--active' : ''}`}
          onClick={onOpenFilterPanel}
        >
          <FilterIcon />
          <span>Filters</span>
          {hasActiveFilters && (
            <span className="toolbar-filter-btn__badge">{activeFilterCount}</span>
          )}
        </button>
        {hasActiveFilters ? (
          <button
            type="button"
            className="toolbar-clear-btn"
            onClick={onClearFilters}
            disabled={loading}
          >
            Clear
          </button>
        ) : null}
      </div>
    </div>
  );
};

BrowseToolbar.propTypes = {
  filters: PropTypes.object.isRequired,
  onQuickFilterChange: PropTypes.func.isRequired,
  onOpenFilterPanel: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  activeFilterCount: PropTypes.number.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
};

export default BrowseToolbar;
